"use client";
import React from "react";
import { useTranslation } from "react-i18next";
import "../../styles/EventNavigationResponsive.css";

const NavigationTabs = ({
  activeTab,
  onTabChange,
  badgeCounts = {},
  compactDesktop = false,
  tabs: customTabs = null,
}) => {
  const { t } = useTranslation("events");

  const tabs = customTabs || [
    { label: t("navigation_tabs.all"), value: "all" },
    { label: t("navigation_tabs.for_you"), value: "for_you" },
    { label: t("navigation_tabs.joined"), value: "joined" },
    { label: t("navigation_tabs.liked"), value: "liked" },
  ];

  const getBadgeLabel = (count) => {
    const n = Number(count) || 0;
    if (n <= 0) return "";
    if (n > 999) return "999+";
    return String(n);
  };

  return (
    <div className={`w-full px-0 ${compactDesktop ? "lg:min-w-0" : "lg:w-auto"}`}>
      <nav
        className={`vg-event-navigation-tabs flex justify-between mt-2 mb-1 whitespace-nowrap ${
          compactDesktop
            ? "lg:grid lg:grid-cols-4 lg:gap-x-3 lg:w-full lg:items-start lg:justify-items-start lg:overflow-hidden"
            : "lg:justify-start lg:gap-8"
        }`}
      >
        {tabs.map(({ label, value }) => {
          const rawCount = badgeCounts?.[value] || 0;
          const badge = getBadgeLabel(rawCount);
          return (
          <button
            key={value}
            onClick={() => onTabChange(value)}
            className={`vg-event-navigation-tab relative font-semibold tracking-tight cursor-pointer text-2xl ${
              compactDesktop
                ? "lg:min-w-0 lg:w-full lg:text-left lg:text-[1.1rem] xl:text-[1.22rem] lg:leading-tight"
                : ""
            }`}
            aria-selected={activeTab === value}
            role="tab"
          >
            <span className={`vg-event-navigation-label ${activeTab === value ? "text-white" : "text-white/50"}`}>
              {label}
            </span>
            {badge ? (
              <span
                className={`absolute z-10 bg-white text-blue-600 font-extrabold leading-none h-[18px] min-w-[18px] px-[5px] rounded-full text-[11px] flex items-center justify-center shadow-[0_0_8px_rgba(255,255,255,0.45)] ${
                  compactDesktop
                    ? "-top-[2px] -left-[12px] lg:-top-[4px] lg:-left-[8px]"
                    : "-top-[2px] -left-[12px]"
                }`}
                aria-hidden="true"
              >
                {badge}
              </span>
            ) : null}
          </button>
          );
        })}
      </nav>
    </div>
  );
};

export default NavigationTabs;
